module.exports = __webpack_public_path__ + "img/nav-medical.6e8da994.svg";